/* =========================================================
   FIGS-style Product Gallery & Lightbox
   Cleemedic custom addon — no modifica los archivos core de Dawn
   ========================================================= */
(function () {
  function localDebounce(fn, wait) {
    let t;
    return function (...args) {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }

  const ARROW_LEFT_SVG =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 18l-6-6 6-6"/></svg>';
  const ARROW_RIGHT_SVG =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 6l6 6-6 6"/></svg>';

  /* ---------------- DESKTOP MAIN GALLERY: hover arrows + loop ---------------- */
  function initDesktopArrows(galleryEl) {
    if (galleryEl.dataset.figsArrowsInit) return;
    const viewer = galleryEl.querySelector('slider-component[id^="GalleryViewer-"]');
    const list = galleryEl.querySelector('ul[id^="Slider-Gallery-"]');
    if (!viewer || !list) return;
    galleryEl.dataset.figsArrowsInit = 'true';

    viewer.style.position = viewer.style.position || 'relative';

    const prevBtn = document.createElement('button');
    prevBtn.type = 'button';
    prevBtn.className = 'figs-gallery-arrow figs-gallery-arrow--prev';
    prevBtn.setAttribute('aria-label', 'Imagen anterior');
    prevBtn.innerHTML = ARROW_LEFT_SVG;

    const nextBtn = document.createElement('button');
    nextBtn.type = 'button';
    nextBtn.className = 'figs-gallery-arrow figs-gallery-arrow--next';
    nextBtn.setAttribute('aria-label', 'Imagen siguiente');
    nextBtn.innerHTML = ARROW_RIGHT_SVG;

    function currentItems() {
      // Excluye imágenes que pertenecen a otra variante (marcadas con .hide-image)
      return Array.from(list.children).filter(
        (el) => el.hasAttribute('data-media-id') && !el.classList.contains('hide-image')
      );
    }

    function goTo(direction) {
      const items = currentItems();
      if (items.length < 2) return;
      const activeIndex = items.findIndex((el) => el.classList.contains('is-active'));
      let nextIndex = activeIndex + direction;
      if (nextIndex < 0) nextIndex = items.length - 1;
      if (nextIndex >= items.length) nextIndex = 0;
      const targetId = items[nextIndex].dataset.mediaId;
      if (typeof galleryEl.setActiveMedia === 'function') {
        galleryEl.setActiveMedia(targetId, false);
      }
    }

    prevBtn.addEventListener('click', (e) => {
      e.preventDefault();
      goTo(-1);
    });
    nextBtn.addEventListener('click', (e) => {
      e.preventDefault();
      goTo(1);
    });

    viewer.appendChild(prevBtn);
    viewer.appendChild(nextBtn);
  }

  /* ---------------- LIGHTBOX: counter + arrows + infinite swipe ---------------- */
  function setupModal(modalEl) {
    if (modalEl.dataset.figsModalInit) return;
    const dialog = modalEl.querySelector('.product-media-modal__dialog');
    const content = modalEl.querySelector('.product-media-modal__content');
    if (!dialog || !content) return;
    modalEl.dataset.figsModalInit = 'true';

    const counter = document.createElement('div');
    counter.className = 'product-media-modal__counter';
    counter.setAttribute('aria-hidden', 'true');
    counter.innerHTML =
      '<span class="product-media-modal__counter-current">1</span> / <span class="product-media-modal__counter-total">1</span>';
    dialog.appendChild(counter);

    const prevBtn = document.createElement('button');
    prevBtn.type = 'button';
    prevBtn.className = 'product-media-modal__nav product-media-modal__nav--prev';
    prevBtn.setAttribute('aria-label', 'Imagen anterior');
    prevBtn.innerHTML = ARROW_LEFT_SVG;

    const nextBtn = document.createElement('button');
    nextBtn.type = 'button';
    nextBtn.className = 'product-media-modal__nav product-media-modal__nav--next';
    nextBtn.setAttribute('aria-label', 'Imagen siguiente');
    nextBtn.innerHTML = ARROW_RIGHT_SVG;

    dialog.appendChild(prevBtn);
    dialog.appendChild(nextBtn);

    const counterCurrent = counter.querySelector('.product-media-modal__counter-current');
    const counterTotal = counter.querySelector('.product-media-modal__counter-total');

    function realItems() {
      return Array.from(content.children).filter(
        (el) =>
          el.hasAttribute('data-media-id') &&
          !el.classList.contains('figs-clone') &&
          !el.classList.contains('hide-image')
      );
    }

    function updateCounter() {
      const items = realItems();
      const idx = items.findIndex((el) => el.classList.contains('active'));
      counterCurrent.textContent = idx > -1 ? idx + 1 : 1;
      counterTotal.textContent = items.length;
      const hasMultiple = items.length > 1;
      prevBtn.style.display = hasMultiple ? '' : 'none';
      nextBtn.style.display = hasMultiple ? '' : 'none';
      counter.style.display = hasMultiple ? '' : 'none';
    }

    function setActive(target) {
      content.querySelectorAll('[data-media-id], .figs-clone').forEach((el) => el.classList.remove('active'));
      target.classList.add('active');
    }

    function goTo(direction) {
      const items = realItems();
      if (items.length < 2) return;
      const currentIndex = items.findIndex((el) => el.classList.contains('active'));
      let nextIndex = currentIndex + direction;
      if (nextIndex < 0) nextIndex = items.length - 1;
      if (nextIndex >= items.length) nextIndex = 0;
      const target = items[nextIndex];
      setActive(target);
      content.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
      updateCounter();
    }

    prevBtn.addEventListener('click', (e) => {
      e.preventDefault();
      goTo(-1);
    });
    nextBtn.addEventListener('click', (e) => {
      e.preventDefault();
      goTo(1);
    });

    // El tema cierra el modal al detectar un pointerup fuera de la imagen;
    // evitamos que ese cierre se dispare al usar nuestras flechas o el contador.
    prevBtn.addEventListener('pointerup', (e) => e.stopPropagation());
    nextBtn.addEventListener('pointerup', (e) => e.stopPropagation());
    counter.addEventListener('pointerup', (e) => e.stopPropagation());

    modalEl.addEventListener('keydown', (e) => {
      if (!modalEl.hasAttribute('open')) return;
      if (e.key === 'ArrowLeft') goTo(-1);
      if (e.key === 'ArrowRight') goTo(1);
    });

    // Clona la primera y última imagen para permitir loop infinito al deslizar con el dedo
    function setupClones() {
      if (content.dataset.figsClonesInit) return;
      const items = realItems();
      if (items.length < 2) return;
      content.dataset.figsClonesInit = 'true';

      const firstClone = items[0].cloneNode(true);
      const lastClone = items[items.length - 1].cloneNode(true);
      firstClone.classList.add('figs-clone');
      lastClone.classList.add('figs-clone');
      firstClone.removeAttribute('data-media-id');
      lastClone.removeAttribute('data-media-id');
      firstClone.classList.remove('active');
      lastClone.classList.remove('active');

      content.insertBefore(lastClone, content.firstChild);
      content.appendChild(firstClone);
    }

    let scrollTimeout;
    content.addEventListener('scroll', () => {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => {
        const children = Array.from(content.children).filter((el) => !el.classList.contains('hide-image'));
        let closest = null;
        let closestDist = Infinity;
        children.forEach((el) => {
          const dist = Math.abs(el.offsetLeft - content.scrollLeft);
          if (dist < closestDist) {
            closestDist = dist;
            closest = el;
          }
        });
        if (!closest) return;

        if (closest.classList.contains('figs-clone')) {
          const isCloneOfFirst = closest === content.lastElementChild;
          const items = realItems();
          const target = isCloneOfFirst ? items[0] : items[items.length - 1];
          setActive(target);
          content.scrollLeft = target.offsetLeft;
        } else if (closest.hasAttribute('data-media-id')) {
          setActive(closest);
        }
        updateCounter();
      }, 120);
    });

    // Recalcula posición y clones cada vez que se abre el modal
    const observer = new MutationObserver(() => {
      if (modalEl.hasAttribute('open')) {
        setupClones();
        window.setTimeout(() => {
          const items = realItems();
          const active = items.find((el) => el.classList.contains('active')) || items[0];
          if (active) content.scrollLeft = active.offsetLeft;
          updateCounter();
        }, 50);
      }
    });
    observer.observe(modalEl, { attributes: true, attributeFilter: ['open'] });

    updateCounter();
  }

  /* ---------------- MÓVIL: título/precio/impuestos arriba de la foto ---------------- */
  function setupMobileProductHeader(productEl) {
    if (productEl.dataset.figsMobileHeaderInit) return;
    const mediaWrapper = productEl.querySelector('.product__media-wrapper');
    const infoWrapper = productEl.querySelector('.product__info-wrapper');
    if (!mediaWrapper || !infoWrapper) return;

    const titleEl = infoWrapper.querySelector('.product__title');
    const ratingEl = infoWrapper.querySelector('.rating-wrapper');
    const priceEl = infoWrapper.querySelector('[id^="price-"]');
    const taxEl = infoWrapper.querySelector('.product__tax');
    const sourceEls = [titleEl, ratingEl, priceEl, taxEl].filter(Boolean);
    if (!sourceEls.length) return;
    productEl.dataset.figsMobileHeaderInit = 'true';

    const mobileHeader = document.createElement('div');
    mobileHeader.className = 'figs-mobile-product-header';
    mobileHeader.setAttribute('aria-hidden', 'true');
    mediaWrapper.parentNode.insertBefore(mobileHeader, mediaWrapper);

    // Marcamos los originales para ocultarlos en móvil vía CSS
    // (siguen en el DOM funcionando normal, ej. al cambiar de variante)
    sourceEls.forEach((el) => el.classList.add('figs-has-mobile-mirror'));

    function sync() {
      mobileHeader.innerHTML = '';
      sourceEls.forEach((el) => {
        const clone = el.cloneNode(true);
        clone.removeAttribute('id');
        clone.classList.remove('figs-has-mobile-mirror');
        mobileHeader.appendChild(clone);
      });
    }

    sync();

    const observer = new MutationObserver(sync);
    sourceEls.forEach((el) => {
      observer.observe(el, { childList: true, subtree: true, characterData: true });
    });
  }

  function init(root) {
    root.querySelectorAll('media-gallery').forEach(initDesktopArrows);
    root.querySelectorAll('product-modal').forEach(setupModal);
    root.querySelectorAll('.product').forEach(setupMobileProductHeader);
  }

  document.addEventListener('DOMContentLoaded', () => init(document));
  document.addEventListener('shopify:section:load', () => init(document));

  // Vuelve a escanear si el DOM cambia (por ejemplo al cambiar de variante,
  // Dawn puede re-renderizar la galería y el modal)
  const mo = new MutationObserver(localDebounce(() => init(document), 250));
  if (document.body) {
    mo.observe(document.body, { childList: true, subtree: true });
  } else {
    document.addEventListener('DOMContentLoaded', () => {
      mo.observe(document.body, { childList: true, subtree: true });
    });
  }
})();